import { Skeleton as MantineSkeleton } from '@mantine/core'
import { SkeletonProps } from './skeleton.types'

export const Skeleton = ({ ...props }: SkeletonProps) => (
  <MantineSkeleton {...props} />
)
